<template>
  <div>
    <v-container>
      <v-row justify="center">
        <v-col cols="12" class="title">
          <app-editor :value="JSON.parse(data.description)" :editable="false" />
        </v-col>
        <v-col cols="12" class="body-2">
          <app-editor
            :value="JSON.parse(data.question_group.questions[0].content)"
            :editable="false"
          />
        </v-col>
        <v-col cols="12">
          <v-divider />
        </v-col>
        <v-col cols="12">
          <div class="title mb-2">
            <div
              class="pa-2 d-inline-block"
              style="border: #29284c dashed 1px; border-radius: 10px"
            >
              Student's Answer <v-icon color="#29284c">mdi-arrow-down</v-icon>
            </div>
          </div>
          <div class="comment__editor px-3" @click="onFocus">
            <app-editor
              ref="editor"
              v-model="comment.text"
              :editable="!answered"
              @click.native.stop
            />
          </div>
        </v-col>
        <v-col cols="12" class="text-center">
          <v-btn
            v-if="!answered"
            class="white--text text-capitalize"
            color="#29284c"
            :loading="loading"
            :disabled="answered"
            @click="onSave"
          >
            Save
          </v-btn>
          <ProgressResetButton
            v-else
            :small="false"
            :depressed="false"
            :stepType="stepType"
            :stepUuid="data.uuid"
            @reset="
              onReset();
              comment.text = defaultContent();
            "
          />
          <v-btn
            v-if="isTeacher"
            class="white--text ml-2 text-capitalize"
            color="#29284c"
            :loading="loadingAssign"
            :disabled="finished || disabled"
            @click="assign(data.uuid)"
          >
            {{
              finished || disabled
                ? "Already assigned"
                : `Assign to ${student.first_name} ${student.last_name}`
            }}
          </v-btn>
        </v-col>
        <v-col cols="12">
          <app-comment-group ref="commentGroup" divider :uuid="data.comment_group" />
        </v-col>
      </v-row>
    </v-container>
    <app-student-note v-if="!isTeacher && qualification.note" :note="qualification.note" absolute />
    <app-qualification
      v-if="isTeacher && !qualification.note && qualification.uuid"
      :qualification="qualification"
      absolute
      @new-qual="qualification = $event"
    />
  </div>
</template>
<script>
import homeworkLessonMixin from "@/mixins/homeworkLessonMixin";
import ProgressResetButton from "@/components/Utils/ProgressResetButton.vue";

export default {
  components: {
    ProgressResetButton,
  },
  mixins: [homeworkLessonMixin],
  data() {
    return {
      comment: {
        text: "Type your answer here (if applicable)...",
      },
    };
  },
  methods: {
    onInput(value) {
      this.answers[0].content = JSON.stringify(value);
    },
    onFocus() {
      this.$refs.editor.editor.focus("end");
    },
    defaultContent: () => ({
      type: "doc",
      content: [
        {
          type: "paragraph",
          content: [
            {
              type: "text",
              text: "Type your answer here (if applicable)...",
            },
          ],
        },
      ],
    }),
    onSave() {
      this.answers[0].content = JSON.stringify(this.comment.text);
      this.save();
    },
  },
  watch: {
    answers: {
      handler(value) {
        if (value.length) {
          if (value[0].content) {
            this.comment.text = JSON.parse(value[0].content);
          }
        }
      },
      deep: true,
    },
  },
  created() {
    this.comment.text = this.defaultContent();
  },
};
</script>
<style scoped lang="scss">
.comment__editor {
  border: 1px #949494 solid;
  border-radius: 4px;
}
</style>
